import {cloneElement, isValidElement} from 'react'
import {Layout, useFloatingContext} from '~/components'

const FooterLayout = ({showContentBorders, children}) => (
	<Layout className="popout-footer" direction="vertical" padding="12" width="full" borderTop={showContentBorders}>
		{children}
	</Layout>
)

export const PopoutFooter = ({footer, buttons, ...rest}) => {
	const {setIsOpen} = useFloatingContext()
	const isElement = isValidElement(footer)

	if (isElement) return <FooterLayout {...rest}>{footer}</FooterLayout>

	if (!buttons.length) return null

	const withCloseOnClick = originalHandler => e => {
		originalHandler?.(e)
		setIsOpen(false)
	}

	const enhancedButtons = buttons.map((button, key) => {
		if (!isValidElement(button) || !button.props.onClick) return button
		return cloneElement(button, {key, onClick: withCloseOnClick(button.props.onClick)})
	})

	return <FooterLayout {...rest}>{enhancedButtons}</FooterLayout>
}
